import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

import type { InviteWizardComponent } from "./invite-wizard.component";

@Component({
  selector: "app-invite-wizard-credentials-and-completion",
  templateUrl: "./invite-wizard-credentials-and-completion.component.html",
  host: { style: "display: contents" },
  imports: [CommonModule, ReactiveFormsModule],
  standalone: true
})
export class InviteWizardCredentialsAndCompletionComponent {
  @Input({ required: true }) view!: InviteWizardComponent;
}
